'use strict';

var cache = {};
var utils = require('../util/util');

module.exports = {
    initCache: function () {
        // Init cache
        cache.$modal = $('#lightbox-modal');
        cache.$staticAndModal = $('#lightbox-modal, .lightbox-static-page');
        cache.cookieName= 'EmailSignupModalDismissalCA';
        cache.currentLocaleCookieName = 'EmailSignupModalDismissalCALocale';
        cache.$accordionTrigger = cache.$staticAndModal.find('.js-accordion-trigger');
        cache.$subscribeForm = cache.$staticAndModal.find('.js-subscribe-form');
        cache.$countrySelector = $('.js-country-selector');
        cache.currentLocale = cache.$countrySelector.find('.selected-locale').data('locale');
        cache.subscribeURL = cache.$modal.attr('data-subscribe-url');
        cache.lbConfigs = cache.$modal.attr('data-lb-configs') ? JSON.parse(cache.$modal.attr('data-lb-configs')) : null;

        // Init attributes
        cache.$subscribeForm.attr('action', cache.subscribeURL);
    },
    setCookieFromMarketingEmails: function () {
        var paramValue = '';
        var sourceParam = cache.lbConfigs ? cache.lbConfigs.bbwLightBoxMarketingSourceParam : '';
        var sourceCodes = cache.lbConfigs ? cache.lbConfigs.bbwLightBoxMarketingSourceCodes : '';
        var marketingSourceExpirationDays = cache.lbConfigs ? cache.lbConfigs.bbwLightBoxMarketingSourceExpirationDays : '';
        var setCookieFlag = false;

        if (sourceParam !== '') {
            paramValue = utils.getParameterByName(sourceParam);
        }

        if (paramValue) {
            setCookieFlag = !!utils.findValueInObject(sourceCodes, paramValue);
        }

        if (setCookieFlag) {
            // Set cookie if we submit from marketing emails
            utils.setCookie(cache.cookieName, true, marketingSourceExpirationDays);
            if (utils.getCookie(cache.currentLocaleCookieName) !== '') {
                utils.setCookie(cache.currentLocaleCookieName, cache.currentLocale, marketingSourceExpirationDays);
            }
        }
    },
    insideModalEvents: function () {
        // Accordion event
        cache.$accordionTrigger.on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $accordionContent = $this.closest('.js-modal-content').find('.js-accordion-content');

            $accordionContent.slideToggle();
            $this.toggleClass('mi-open');
        });

        // Subscribe form submit event
        cache.$subscribeForm.submit(function (e) {
            e.preventDefault();
            var $form = $(this);
            var $modalContent = $form.closest('.js-modal-content');
            var isFormPartOfModal = $form.closest('.modal.lightbox-modal').length;

            $modalContent.spinner().start();

            if (cache.subscribeURL === '') {
                return;
            }

            $modalContent.find('.js-confirm-email').val($modalContent.find('.js-email').val());
            $modalContent.removeClass('success-content-bg');

            // Ajax call for subscribe email
            $.ajax({
                url: cache.subscribeURL,
                data: $form.serialize(),
                type: 'post'
            }).done(function () {
                var expirationDays = cache.lbConfigs ? cache.lbConfigs.bbwLightBoxSignupExpirationDays : '';
                // Business decision to not display any success/fail message after the Ajax response is received. In case of failure, just remove the spinner
                $modalContent.find('.js-lb-container').addClass('d-none');
                $modalContent.find('.js-success-container').removeClass('d-none');
                $modalContent.addClass('success-content-bg');

                if (!isFormPartOfModal) {
                    expirationDays = cache.lbConfigs ? cache.lbConfigs.bbwLightBoxOutsideSignupExpirationDays : '';
                }

                // Set cookie after sign up from lightbox modal or outside signup
                utils.setCookie(cache.cookieName, true, expirationDays);
                if (utils.getCookie(cache.currentLocaleCookieName) !== '') {
                    utils.setCookie(cache.currentLocaleCookieName, cache.currentLocale, expirationDays);
                }
            }).always(function () {
                $modalContent.spinner().stop();
            });
        });

        // Modal open event
        cache.$modal.on('show.bs.modal', function () {
            var $languageSelectModal = $('#language-select-modal');
            var $backdrop = $('.modal-backdrop');

            // Remove one backdrop if we have more than one modal open
            if ($languageSelectModal.length > 0) {
                $backdrop[0].remove();
            }
        });
    },
    customEvents: function () {
        $('body').on('emailSubscribe:done', function () {
            // Set cookie if we submit from outside forms
            var expirationDays = cache.lbConfigs ? cache.lbConfigs.bbwLightBoxOutsideSignupExpirationDays : '';

            utils.setCookie(cache.cookieName, true, expirationDays);
            if (utils.getCookie(cache.currentLocaleCookieName) !== '') {
                utils.setCookie(cache.currentLocaleCookieName, cache.currentLocale, expirationDays);
            }
        });
    },
    showModal: function () {
        // Open lightbox modal based on cookie
        if (utils.getCookie(cache.cookieName) === '' && $('[data-render-lightbox]').length > 0) {
            var bbwLightBoxExpirationDays = cache.lbConfigs ? cache.lbConfigs.bbwLightBoxExpirationDays : '';
            utils.setCookie(cache.cookieName, true, bbwLightBoxExpirationDays);
            cache.$modal.modal();

            // Set cookie locale with current locale
            utils.setCookie(cache.currentLocaleCookieName, cache.currentLocale, bbwLightBoxExpirationDays);
        }

        // Open lightbox modal based on cookie locale
        if ($('[data-render-lightbox]').length > 0 && utils.getCookie(cache.currentLocaleCookieName) !== '' && cache.currentLocale !== utils.getCookie(cache.currentLocaleCookieName)) {
            cache.$modal.modal();
            utils.setCookie(cache.currentLocaleCookieName, '', 0);
        }
    }
};
